import {
  OutsideClickHandler,
  Container,
  Typography,
} from "components/ct-design";
import { accoutOptions, tools } from "constants/home";
import { getUserAuthValues } from "src/utils/generalUtils";
import { ILoggedInDropdownProps } from "app/bus/type";
import Clevertap from "src/analytics/index";
import DropdownOptions from "components/dropdown/dropDownOptions";
import "./style.scss";
const LoggedInDropdown: React.FC<ILoggedInDropdownProps> = ({
  onClose,
  accountInfo,
}) => {
  const eventName = "BUS_UI_Action";
  const handleSignout = () => {
    const url = "/signout";
    setTimeout(() => {
      window.location.href = url;
    }, 500);
  };

  const { countryCode, mobile, username } = accountInfo || {};
  const profileName = getUserAuthValues()?.profileName?.replace("+", " ");

  const handleSignedInProfileItemClick = (url: string, actionName: string) => {
    if (actionName) {
      Clevertap.event(eventName, {
        action_type: "Link",
        action_name: actionName,
        action_value: "signed_in",
        ui_index: null,
      });
    }
    if (url.includes("/accounts/hi-five")) {
      Clevertap.event(eventName, {
        action_name: "Hi5_banner_click",
        Hi5_entry_point: "accounts",
        logged_in: "yes",
        // domain: getNestedField(['location', 'hostname'], window),
      });
    }
  };

  const handleProfileItemClick = (actionName: string) => {
    window.localStorage.removeItem("ON_LOGIN_PUSH");
    if (actionName) {
      Clevertap.event(eventName, {
        action_type: "Link",
        action_name: actionName,
        action_value: "signed_in",
        ui_index: null,
      });
    }
  };

  return (
    <>
      <OutsideClickHandler onOutsideClick={onClose}>
        <DropdownOptions
          openDropdown={true}
          wrapperClass="my-account-dropdown p-absolute bg-neutral-100 z-10 "
        >
          <Container
            className="ls-reset br-4 w-100p px-2 dropdown__item c-neutral-900 ta-center"
            paddingTop="10px"
            paddingBottom="6px"
          >
            <Typography variant="HM4">
              {mobile && countryCode
                ? `${countryCode} ${mobile}`
                : `${username ? username : profileName}`}
            </Typography>
          </Container>
          <Container
            className="mb-2 mt-1 d-block flex-1"
            height="1px"
            width="100%"
            backgroundColor="#e6e6e6"
          />
          <Container className="row">
            <Container className="col-12 px-2">
              <Container className="flex flex-middle">
                <Container
                  className="fs-12 fw-400 p-2"
                  css={{ color: "#b3b3b3" }}
                >
                  Account
                </Container>
              </Container>
              <Container>
                {accoutOptions.map((value, index) => {
                  return (
                    <a
                      className="td-none"
                      href={value.link}
                      key={`account-options-${index}`}
                    >
                      <Container
                        onClick={() =>
                          handleSignedInProfileItemClick(
                            value.link,
                            value.actionName
                          )
                        }
                        className="ls-reset br-4 w-100p dropdown__option  c-pointer flex flex-middle p-2"
                      >
                        <Container className="c-neutral-400">
                          {<value.icon />}
                        </Container>

                        <Container className="flex flex-between flex-middle">
                          <Container className="fs-14 mx-2 c-neutral-900">
                            {value.text}
                          </Container>
                        </Container>
                      </Container>
                    </a>
                  );
                })}
              </Container>
            </Container>
            <Container className="col-12 px-2">
              <Container className="flex flex-middle">
                <Container
                  className="fs-12 fw-400 p-2"
                  css={{ color: "#b3b3b3" }}
                >
                  Quick tools
                </Container>
              </Container>
              <Container>
                {tools.map((value, index) => {
                  return (
                    <a
                      className="td-none"
                      href={value.link}
                      key={`tools-${index}`}
                    >
                      <Container
                        onClick={() => handleProfileItemClick(value.actionName)}
                        className="ls-reset br-4 w-100p dropdown__option c-pointer flex flex-middle p-2"
                      >
                        <Container className="c-secondary-500">
                          {<value.icon />}
                        </Container>

                        <Container className="flex flex-between flex-middle">
                          <Container className="fs-14 mx-2 c-secondary-500 card-price">
                            {value.text}
                          </Container>
                        </Container>
                      </Container>
                    </a>
                  );
                })}
              </Container>
            </Container>
          </Container>
          <Container
            className="mb-2 mt-1 d-block flex-1"
            height="1px"
            width="100%"
            backgroundColor="#e6e6e6"
          />
          <Container className="flex flex-right mb-3 mx-3">
            <span
              className="fs-14 c-pointer dropdown__underline"
              style={{ color: "#ff3c2b" }}
              onClick={handleSignout}
            >
              Sign out
            </span>
          </Container>
        </DropdownOptions>
      </OutsideClickHandler>
    </>
  );
};
export default LoggedInDropdown;
